import { render, staticRenderFns } from "./SuppliesInventory.vue?vue&type=template&id=4ddaf5f8"
import script from "./SuppliesInventory.vue?vue&type=script&lang=js"
export * from "./SuppliesInventory.vue?vue&type=script&lang=js"
import style0 from "./SuppliesInventory.vue?vue&type=style&index=0&id=4ddaf5f8&prod&lang=scss"
import style1 from "./SuppliesInventory.vue?vue&type=style&index=1&id=4ddaf5f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports